var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShowIf from "../../App/ShowIf";
import { Icon } from "../../UI";

import { openPanel } from "../actions/uiActions";

export class ViewerDefaultMenu extends Component {
  render() {
    return (/*#__PURE__*/
      _jsx("div", { className: this.props.active ? 'active' : '' }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: !this.props.panelIsOpen }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: "btn btn-primary",
        onClick: this.props.openPanel.bind(null, 'viewMetadataPanel') }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "columns" })
      )
      )
      ));

  }
}

const mapStateToProps = ({ documentViewer }) => ({
  panelIsOpen: !!documentViewer.uiState.get('panel'),
  doc: documentViewer.doc,
  targetDoc: !!documentViewer.targetDoc.get('_id')
});









function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openPanel }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewerDefaultMenu);